import NoListingPlaceholderSvg from '@/../img/no-lisating-placeholder.svg';
import { useMemo } from 'react';
import styled from 'styled-components';
import { ListingsInfoMod } from './listings-info-mod';
import { RegistrationMod } from './registration-mod';

const NO_LISTINGS = 'No listing found for this property.';

const NoListingPlaceholderWrapper = styled.div`
  background-color: rgba(89, 126, 247, 0.05);
  height: 300px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NoListingCaption = styled.div`
  margin-top: 10px;

  ::before {
    content: '${NO_LISTINGS}';
    width: 245px;
    height: 14px;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.88;
    letter-spacing: normal;
    color: #101938;
    display: block;
  }
`;

export function ListingsMod(props) {
  const {
    propertyData,
    listingData,
    currentPlatform,
    platformList,
    platformIcons,
    setCurrentPlatform,
    filterByCurrentPlatform,
  } = props;

  const currentPlatformListings = useMemo(
    () => filterByCurrentPlatform(listingData, currentPlatform),
    [currentPlatform, filterByCurrentPlatform, listingData]
  );

  if (!listingData || listingData.length === 0) {
    return (
      <NoListingPlaceholderWrapper>
        <NoListingPlaceholderSvg aria-label={NO_LISTINGS} />
        <NoListingCaption aria-hidden />
      </NoListingPlaceholderWrapper>
    );
  }

  return (
    <>
      <RegistrationMod
        onSelect={setCurrentPlatform}
        platformList={platformList}
        platformIcons={platformIcons}
        activeTab={currentPlatform}
        listings={listingData}
      />

      <ListingsInfoMod
        currentPlatformListings={currentPlatformListings}
        currentPlatform={currentPlatform}
        listings={listingData}
        platformIcons={platformIcons}
        key={currentPlatform}
        unitType={propertyData.unitType}
        rentalStructure={propertyData.rentalStructure}
      />
    </>
  );
}
